import { createAction, props } from '@ngrx/store';

import { PolicyModel } from '@lockton-apps/client-gateway/interfaces';

export enum PolicyCreateUpdateActionTypes {
  Init = '[PolicyCreateUpdate Page] Init',

  Added = '[PolicyCreateUpdate Page]',
  Updated = '[PolicyCreateUpdate Page] Update Policy]',

  Destroyed = '[PolicyCreateUpdate/Page] Destroyed',
}

export const PolicyCreateUpdateActions = {
  init: createAction(PolicyCreateUpdateActionTypes.Init),
  added: createAction(
    PolicyCreateUpdateActionTypes.Added,
    props<{ policy: PolicyModel }>()
  ),
  updated: createAction(
    PolicyCreateUpdateActionTypes.Updated,
    props<{ policy: PolicyModel }>()
  ),
  destroyed: createAction(PolicyCreateUpdateActionTypes.Destroyed),
};
